import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import { useGetBrandingQuery } from '../services/brandingApi';
// import { BrandingLoading } from '../components/BrandingLoading';

interface IBranding {
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  clientName: string;
  loginMessage: string;
  faviconUrl: string;
}

interface IBrandingContextData {
  branding: IBranding;
  loading: boolean;
}

const BrandingContext = createContext<IBrandingContextData>(
  {} as IBrandingContextData
);

const DEFAULT_BRANDING: IBranding = {
  primaryColor: '#00A99D',
  secondaryColor: '#E6F7F5',
  logoUrl: '/logo-pmis.svg',
  loginMessage: 'Bem-vindo ao PMIS',
  clientName: 'PMIS',
  faviconUrl: '/favicon.ico',
};

export function BrandingProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const { data, isLoading } = useGetBrandingQuery(window.location.hostname, {
    refetchOnMountOrArgChange: false,
  });

  const branding: IBranding = {
    primaryColor: data?.PRIMARY_COLOR || DEFAULT_BRANDING.primaryColor,
    secondaryColor: data?.SECONDARY_COLOR || DEFAULT_BRANDING.secondaryColor,
    logoUrl: data?.LOGO_PATH || DEFAULT_BRANDING.logoUrl,
    loginMessage: data?.LOGIN_MESSAGE || DEFAULT_BRANDING.loginMessage,
    clientName: data?.CLIENT_NAME || DEFAULT_BRANDING.clientName,
    faviconUrl: data?.FAVICON_PATH || DEFAULT_BRANDING.faviconUrl,
  };

  useEffect(() => {
    if (branding.primaryColor) {
      document.documentElement.style.setProperty(
        '--marine_medium',
        branding.primaryColor
      );

      document.documentElement.style.setProperty(
        '--green-sea_medium',
        branding.primaryColor
      );
    }

    if (branding.secondaryColor) {
      document.documentElement.style.setProperty(
        '--marine_light',
        branding.secondaryColor
      );
    }
    if (branding.faviconUrl) {
      let favicon = document.querySelector(
        "link[rel='icon']"
      ) as HTMLLinkElement;

      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }

      favicon.href = branding.faviconUrl;
    }
  }, [branding]);

  const contextValue = useMemo(
    () => ({
      branding,
      loading: isLoading,
    }),
    [branding, isLoading]
  );

  // if (isLoading) {
  //   return <BrandingLoading />;
  // }

  return (
    <BrandingContext.Provider value={contextValue}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const context = useContext(BrandingContext);

  if (!context) {
    throw new Error('useBranding deve ser usado dentro de um BrandingProvider');
  }

  return context;
}
